module.exports = __webpack_public_path__ + "img/CLAUDIA.d3ee6595.jpeg";